import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useDispatch, useSelector} from 'react-redux';
import {CloseOutlined} from '@mui/icons-material';
import {logout, setErrors} from '../store/features/app/appSlice';
import {Alert, CircularProgress} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {login} from '../store/features/app/appActions';
import {t} from 'i18next';

export default function ErrorDialog() {

    const {error, loading} = useSelector(state => state.app)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    if (error == "Request failed with status 403. Response: Access denied") {
        dispatch(logout())
    }
    const apiError = error == "API_NOT_REACHABLE"

    return (

        <Dialog
            open={error != null}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        > <CloseOutlined sx={{marginLeft: "auto"}} onClick={() => dispatch(setErrors(null))}></CloseOutlined>
            <DialogTitle id="alert-dialog-title">
                <Alert severity="error">   {t("messages.errorTittle")}</Alert>

            </DialogTitle>

            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {apiError ? t("messages.apiError") : error}
                </DialogContentText>

                {apiError && <DialogActions>
                    <Button endIcon={loading ? <CircularProgress></CircularProgress> : null} autoFocus
                            onClick={() => dispatch(login())} variant="contained">
                        {t("messages.tryAgain")}
                    </Button>
                </DialogActions>
                }
            </DialogContent>
        </Dialog>
    );
}